import {InvalidArgumentException} from "./exceptions";
import {PropertiesOnly} from "@livechat/shared";

export abstract class TagBase {
  readonly id: number;
  readonly color: TagColor;
  readonly name: string;
  readonly type: TagType;

  protected constructor(props: PropertiesOnly<TagBase>) {
    this.id = props.id
    this.color = props.color
    this.name = props.name
    this.type = props.type

    this.validate(this)
  }

  private validate(tag: TagBase) {
    if (!tag.color) {
      throw new InvalidArgumentException('color', 'required')
    }
    if (!tag.name) {
      throw new InvalidArgumentException('name', 'required')
    }
  }

}

export enum TagType {
  CUSTOM = 'custom',
  EVENT = 'event',
  HUMAN_REQUEST = 'human_request',
  LINK_QUOTATION_OPENED = 'link_quotation_opened',
  QUOTATION = 'quotation',
  VOICE_CALL_ANSWERED = 'voice_call_answered',
  VOICE_CALL_BUSY = 'voice_call_busy',
  VOICE_CALL_MISS = 'voice_call_miss',
}

export const TagColors = [
  '#CDF9F3',
  '#D4DAF3',
  '#CEEEAA',
  '#FBC5FF',
  '#FED5C9',
  '#DDBFE5',
  '#FFE0B2',
  '#B2E5FD',
  '#EFC89C',
  '#E4E7EB',
] as const

export type TagColor = typeof TagColors[number]
